// import Swiper bundle with all modules installed
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const swiperUpsell = new Swiper(".content-slider-upsell", {
  // Optional parameters
  modules: [Navigation],
  loop: true,
  slidesPerView: 2,
  spaceBetween: 12,

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});



const swiperCollection = new Swiper(".collection-slider-products", {
  // Optional parameters
  loop: true,
  slidesPerView: 4,
  spaceBetween: 15,

  breakpoints: {
    280: {
      spaceBetween: 5,
      slidesPerView: 2,
    },
    768: {
      spaceBetween: 5,
      slidesPerView: 3,
    },
    1300: {
      slidesPerView: 4,
    },
  },
});

const loadHeader = () => {
  let megamenuSliders = [...document.querySelectorAll(".megamenu")];

  if (megamenuSliders.length === 0) return false;

  //megamenuSliders.map(menuSlider => initializeSwiperHeader(menuSlider));

  let sidebar_menu = document.querySelector("#header-kings__navigation");

  let nav_toggle = document.querySelector(".header-kings__nav-toggle");
  if (nav_toggle) {
    nav_toggle.addEventListener("click", function () {
      sidebar_menu.setAttribute("data-show", true);
    });
  }

  let nav_toggleTwo = document.querySelector(".header-kings__nav-toggle-two");
  if (nav_toggleTwo) {
    nav_toggleTwo.addEventListener("click", function () {
      sidebar_menu.setAttribute("data-show", true);
    });
  }

  let nav_close = document.querySelector("#header-kings-nav-mobile--close");
  if (nav_close) {
    nav_close.addEventListener("click", function () {
      sidebar_menu.setAttribute("data-show", false);
    });
  }

  document
    .querySelector(".trigger-discount-modal")
    ?.addEventListener("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "Y3RABU"]);
    });

  window.addEventListener("scroll", function () {
    var scrollPosition = window.scrollY; // Posición actual del scroll
    var windowHeight = window.innerHeight; // Altura de la ventana del navegador
    var bodyHeight = document.body.offsetHeight; // Altura del cuerpo de la página

    // Si la posición del scroll + la altura de la ventana es mayor o igual a la altura del cuerpo de la página
    if (scrollPosition + windowHeight >= bodyHeight) {
      // Agregar la clase 'highlight' al cuerpo de la página
      document.body.classList.add("highlight");
    } else {
      // Si no estamos al final de la página, asegurémonos de que la clase no esté presente
      document.body.classList.remove("highlight");
    }
  });
};

loadHeader();